import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BdsHelpersModule } from '@bds/helpers';

@NgModule({ imports: [BdsHelpersModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class BdsDataAccessModule {}
